window.debug = {
    log:            $.noop,
    info:           $.noop,
    warn:           $.noop,
    error:          $.noop,
    dir:            $.noop,
    dirxml:         $.noop,
    group:          $.noop,
    groupEnd:       $.noop,
    groupCollapsed: $.noop,
    time:           $.noop,
    timeEnd:        $.noop,
    profile:        $.noop,
    profileEnd:     $.noop,
    assert:         $.noop
};

if (document.cookie.match('isDebug=true') || /\.dev/.test(document.location.origin)) {
    window.debug = window.console;

    typeof window.debug.group    == 'undefined' ? window.debug.group    = window.console.info : '';
    typeof window.debug.groupEnd == 'undefined' ? window.debug.groupEnd = window.console.info : '';
}